import React from "react";
import { SUPPORT_EMAIL } from "../../../config";
import Bouton from "../../common/HorsConnexion/Bouton";
import CompteurBlocage from "../../common/HorsConnexion/CompteurBlocage";
import MessageEtat from "../../common/HorsConnexion/MessageEtat";
import PiedCarte from "../../common/HorsConnexion/PiedCarte";
import Saisie from "../../common/HorsConnexion/Saisie";

/**
 * Vue « identifiants » de la connexion. `erreurs` est state.errors tel que
 * rempli par l'API : login / password (sous le champ), nbAttempts (tentatives
 * restantes), timer (blocage temporaire), other (message générique).
 */
const FormulaireConnexion = ({
  login,
  password,
  onLogin,
  onPassword,
  onSubmit,
  erreurs = {},
  isLoading = false,
  bloque = false,
  timer = 0,
  onFinBlocage,
  onMotDePasseOublie,
}) => {
  const nbTentatives = Number(erreurs.nbAttempts) || 0;
  const afficherTentatives = !bloque && nbTentatives > 0;
  const afficherAutre =
    !bloque && !afficherTentatives && !erreurs.login && !erreurs.password && !!erreurs.other;

  let libelle = "Se connecter";
  if (bloque) libelle = "Connexion indisponible";
  else if (isLoading) libelle = "Connexion en cours…";

  return (
    <section aria-labelledby="titre-connexion">
      <h2 id="titre-connexion">Connexion</h2>
      <p className="sous-titre">Identifiez-vous avec votre adresse e-mail professionnelle.</p>

      <form onSubmit={onSubmit} noValidate>
        <Saisie
          id="login"
          label="Adresse e-mail"
          type="email"
          value={login}
          onChange={(e) => onLogin(e.target.value)}
          erreur={erreurs.login || null}
          autoComplete="username"
          inputMode="email"
          placeholder="prenom.nom@exemple.fr"
          autoFocus={!login}
        />
        <Saisie
          id="password"
          label="Mot de passe"
          revelable
          value={password}
          onChange={(e) => onPassword(e.target.value)}
          erreur={erreurs.password || null}
          enErreur={afficherTentatives}
          autoComplete="current-password"
          placeholder="••••••••••"
          autoFocus={!!login}
        />

        <div className="ligne">
          <span />
          <button type="button" className="lien" onClick={onMotDePasseOublie}>
            Mot de passe oublié ?
          </button>
        </div>

        {afficherTentatives && (
          <MessageEtat ton="avert" icone="alerte">
            Identifiants incorrects. Il vous reste <strong>{nbTentatives}</strong>{" "}
            {nbTentatives > 1 ? "tentatives" : "tentative"} avant le blocage temporaire de votre
            compte.
          </MessageEtat>
        )}

        {bloque && (
          <MessageEtat
            ton="danger"
            icone="cadenas"
            complement={<CompteurBlocage secondes={timer} onFin={onFinBlocage} />}
          >
            <strong>Accès temporairement bloqué</strong> après plusieurs tentatives infructueuses.
            Vous pourrez réessayer dans :
          </MessageEtat>
        )}

        {afficherAutre && (
          <MessageEtat ton="danger" icone="alerte">
            {erreurs.other}
          </MessageEtat>
        )}

        <Bouton type="submit" charge={isLoading} disabled={bloque}>
          {libelle}
        </Bouton>
      </form>

      <PiedCarte>
        {SUPPORT_EMAIL ? (
          <>
            Besoin d'aide ? <a href={`mailto:${SUPPORT_EMAIL}`}>Contacter le support</a>
          </>
        ) : (
          "Besoin d'aide ? Contactez votre administrateur."
        )}
      </PiedCarte>
    </section>
  );
};

export default FormulaireConnexion;
